import axios, { AxiosError, AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { isDemoSession } from '@services/demo/demoAccount';
import { demoGetPayload, isDemoMutationBlocked } from '@services/demo/demoApi';

const axiosConfig: AxiosRequestConfig = {
  baseURL: `${process.env.REACT_APP_API_URL}`,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
  },
  withCredentials: true,
};

export const instance = axios.create(axiosConfig);

instance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  if (!isDemoSession()) return config;
  const url = config.url || '';
  const isAuthLogin = url.includes('/login') && !url.includes('/check-login');

  if (isAuthLogin) return config;

  if (isDemoMutationBlocked(config.method, url) || url.includes('/download')) {
    config.adapter = async (cfg) => {
      throw new AxiosError(
        '체험 계정은 화면 조회만 가능합니다.',
        AxiosError.ERR_BAD_REQUEST,
        cfg,
        null,
        {
          status: 403,
          statusText: 'Forbidden',
          headers: {},
          config: cfg,
          data: { message: '체험 계정은 화면 조회만 가능합니다.' },
        },
      );
    };
    return config;
  }

  const payload = demoGetPayload(url, config.params);
  config.adapter = async (cfg) => {
    const response: AxiosResponse = {
      data: payload === undefined ? [] : payload,
      status: 200,
      statusText: 'OK',
      headers: {},
      config: cfg,
    };
    return response;
  };
  return config;
});

// check-login 401: 로그인 전 정상 응답 → 에러 throw 방지 (Uncaught runtime errors 해결)
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url ?? '';
    if (url.includes('check-login') && error.response?.status === 401) {
      return Promise.resolve({ data: null, status: 200 });
    }
    return Promise.reject(error);
  },
);
